import { Paper, PaperProps } from '@mui/material'
import { useForkRef } from '@mui/material/utils'
import { forwardRef, useRef } from 'react'
import { DIALOG_CLOSE_ATTRIBUTE } from 'src/theme/overrides/Dialog'

import CloseButton from './CloseButton'

// ----------------------------------------------------------------------
// The paper every `useConfirm` dialog is drawn on, with the close mark the
// console's other dialogs have.
//
// `material-ui-confirm` renders MUI's dialog itself, so it cannot be handed
// `components/Dialog`, and it keeps the handler that settles the question to
// itself. What it does take is a paper and the cancel button's props, and
// that is enough: the mark presses the dialog's own Cancel, so leaving by the
// corner is the same answer as leaving by the foot, and every caller's
// `.catch` runs exactly as it does for Cancel.
// ----------------------------------------------------------------------

/** Set on the confirm dialog's Cancel by `CONFIRM_DEFAULTS`. */
export const CONFIRM_CANCEL_CLASS = 'beast-confirm-cancel'

const ConfirmPaper = forwardRef<HTMLDivElement, PaperProps>(
  function ConfirmPaper({ children, ...props }, ref) {
    const paper = useRef<HTMLDivElement>(null)
    const handleRef = useForkRef(ref, paper)

    return (
      <Paper ref={handleRef} {...props}>
        {children}
        <CloseButton
          {...{ [DIALOG_CLOSE_ATTRIBUTE]: '' }}
          onClick={() =>
            paper.current
              ?.querySelector<HTMLElement>(`.${CONFIRM_CANCEL_CLASS}`)
              ?.click()
          }
        />
      </Paper>
    )
  },
)

export default ConfirmPaper
